import React from 'react'
import Img from 'gatsby-image/withIEPolyfill'
//

// Get URL parameter helper
const getUrlParameter = (url, query) => {
  // eslint-disable-next-line
  const name = query.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  // eslint-disable-next-line
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`)
  const results = regex.exec(url)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const ImageFluid = ({
  image,
  alt = '',
  loading = 'lazy',
  aspectRatio = 1,
  fadeIn = true,
  className,
  ...rest
}) => {
  if (!image?.fluid) {
    return null
  }

  const { fluid } = image

  if (!fluid?.src) {
    return null
  }

  let orientation

  if (aspectRatio >= 1.2) orientation = 'landscape'
  if (aspectRatio <= 0.8) orientation = 'portrait'
  if (aspectRatio > 0.8 && aspectRatio < 1.2) orientation = 'square'

  return (
    <Img
      fluid={image.fluid}
      alt={alt}
      loading={loading}
      fadeIn={fadeIn}
      className={`${className} ${orientation}`}
      {...rest}
    />
  )
}

export const ImageFixed = ({ image, alt = '', loading = 'lazy', fadeIn = true, className, ...rest }) => {
  if (!image?.fixed) {
    return null
  }

  const { fixed } = image

  if (!fixed?.src) {
    return null
  }

  if (!fixed.width) {
    fixed.width = parseInt(getUrlParameter(fixed.src, 'w'), 10)
  }
  if (!fixed.height) {
    fixed.height = parseInt(getUrlParameter(fixed.src, 'h'), 10)
  }
  if (!fixed.srcSet) {
    fixed.srcSet = `${image.fixed.src} 1x`
  }

  return (
    <Img
      fixed={fixed}
      alt={alt}
      objectFit="contain"
      loading={loading}
      fadeIn={fadeIn}
      className={className}
      {...rest}
    />
  )
}
